import averageTransactionValue from "./reports/average-transaction-value";
import averageUnitsPerTransaction from "./reports/average-units-per-transaction";
import customTotalGrossProfit from "./reports/custom-total-gross-profit";
import customTotalRevenue from "./reports/custom-total-revenue";
import dayOfWeekPerformance from "./reports/day-of-week-performance";
import hourOfDayPerformance from "./reports/hour-of-day-performance";
import recentSales from "./reports/recent-sales";
import saleTypeBreakdown from "./reports/sale-type-breakdown";
import topSellingProducts from "./reports/top-selling-products";
import saleTypeTimeSeriesSales from "./reports/sale-type-time-series-sales";
import timeSeriesGrossProfit from "./reports/time-series-gross-profit";
import timeSeriesRevenueVsGrossProfit from "./reports/time-series-revenue-vs-gross-profit";
import timeSeriesRevenue from "./reports/time-series-revenue";
import timeSeriesUnitsSold from "./reports/time-series-units-sold";
import topOrdersByRevenue from "./reports/top-orders-by-revenue";
import totalInventoryCount from "./reports/total-inventory-count";
import totalInventoryValue from "./reports/total-inventory-value";
import totalTransactions from "./reports/total-transactions";
import uniqueProducts from "./reports/unique-products";
import topSellingCategories from "./reports/top-selling-categories";
import topSellingDepartments from "./reports/top-selling-departments";
import topSellingSuppliers from "./reports/top-selling-suppliers";
import customTrendingProductUp from "./reports/custom-trending-product-up";
import productsSellTogether from "./reports/products-sell-together";
import yearOverYearTrend from "./reports/year-over-year-trend";
import customTrendingProductDown from "./reports/custom-trending-products-down";
import abcAnalysisValue from "./reports/abc-analysis-value";
import abcAnalysisByProduct from "./reports/abc-analysis-by-product";
import whatAmIMissingOutOn from "./reports/what-am-i-missing-out-on";
import weblinkSales15 from "./reports/weblink-sales15";
import weblinkSales19 from "./reports/weblink-sales-19";
import kioskSales from "./reports/kiosk-sales";
import roamSales from "./reports/roam-sales";

// configure the reports
const reports = [
  roamSales,
  kioskSales,
  weblinkSales15,
  weblinkSales19,
  whatAmIMissingOutOn,
  abcAnalysisValue,
  abcAnalysisByProduct,
  yearOverYearTrend,
  averageTransactionValue,
  averageUnitsPerTransaction,
  customTotalGrossProfit,
  customTotalRevenue,
  dayOfWeekPerformance,
  hourOfDayPerformance,
  recentSales,
  topSellingProducts,
  saleTypeBreakdown,
  saleTypeTimeSeriesSales,
  timeSeriesGrossProfit,
  timeSeriesRevenueVsGrossProfit,
  timeSeriesRevenue,
  timeSeriesUnitsSold,
  topOrdersByRevenue,
  totalInventoryCount,
  totalInventoryValue,
  totalTransactions,
  uniqueProducts,
  topSellingCategories,
  topSellingDepartments,
  topSellingSuppliers,
  customTrendingProductUp,
  customTrendingProductDown,
  productsSellTogether,
];

export default reports;
